import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MultipleChoiceGroup,
  TemplatesApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { responseMultipleChoicesQueryKeys } from './queryKeys'

/**
 * 従来の選択肢（他のひな形でも使用中）を削除する
 */
export const useMutationDeleteMultipleChoices = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (multipleChoiceId: number): Promise<void> => {
      return await baseClient
        .getApi(TemplatesApi)
        .deleteResponseMultipleChoices({
          multipleChoiceId,
        })
        .catch(handleHTTPError)
    },
    onSuccess: (_, deletedId) => {
      queryClient.setQueryData<MultipleChoiceGroup[]>(
        responseMultipleChoicesQueryKeys.all,
        (old = []) => old.filter(group => group.id !== deletedId),
      )
    },
  })
}
